import React from 'react';
export const StatsBar = () => {
  return <div className="border-y border-legal-700 bg-legal-800/50 py-8" data-id="element-260">
      <div className="container mx-auto px-4" data-id="element-261">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x-0 md:divide-x divide-legal-700" data-id="element-262">
          <div className="flex flex-col items-center justify-center" data-id="element-263">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-264">+500</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-265">
              Abogados confían
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-266">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-267">100%</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-268">
              Modelos listos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-269">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-270">2026</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-271">
              Jurisprudencia actual
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-272">
            <span className="text-3xl mb-1" data-id="element-273">🇦🇷</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-274">
              Todo el país
            </span>
          </div>
        </div>
      </div>
    </div>;
};